import przeszlosc_2_1 from "assets/img/archive/2/przeszlosc_2_1.jpg";
import przeszlosc_2_2 from "assets/img/archive/2/przeszlosc_2_2.jpg";
import przeszlosc_2_3 from "assets/img/archive/2/przeszlosc_2_3.jpg";
import przeszlosc_2_4 from "assets/img/archive/2/przeszlosc_2_4.jpg";
import { useState } from "react";
import { Fragment, useEffect } from "react";
import { useTranslation } from "react-i18next";

const pages = [
  {
    image: przeszlosc_2_1,
    textLeft: `ArchiveSecondContentLeft1`,
    textRight: `ArchiveSecondContentRight1`,
    character: `Henryka Tomtas`,
  },
  {
    image: przeszlosc_2_2,
    textLeft: `ArchiveSecondContentLeft2`,
    textRight: `ArchiveSecondContentRight2`,
    character: `Henryka Tomtas`,
  },
  {
    image: przeszlosc_2_3,
    textLeft: `ArchiveSecondContentLeft3`,
    textRight: `ArchiveSecondContentRight3`,
    character: `Danuta Serwan`,
  },
  {
    image: przeszlosc_2_4,
    textLeft: `ArchiveSecondContentLeft4`,
    textRight: `ArchiveSecondContentRight4`,
    character: `Bożena Żugaj`,
  },
];

const ArchiveSecond = ({
  setPageTitle,
  setShowMenuToggler,
  setIsBackgroundMusic,
  setReturnLink,
}) => {
  const { t } = useTranslation();
  useEffect(() => {
    setPageTitle(t("archive"));
    setShowMenuToggler(true);
    setIsBackgroundMusic(true);
    setReturnLink({ link: "/scene", from: "archive" });
  }, [setPageTitle, setShowMenuToggler, setReturnLink, setIsBackgroundMusic]);

  const [page, setPage] = useState(0);
  const changePage = (amount) => {
    setPage((currentPage) => {
      const page = currentPage + amount;
      if (page >= 0 && page <= 3) return page;
      return currentPage;
    });
  };
  return (
    <Fragment>
      <div className="container-fluid px-4 mt-5 pt-5">
        <div className="row gx-5">
          <div className="col-md-8 pt-1 mt-1">
            <div className="ps-3 pe-2 me-1 position-relative min-vh-75 user-select-none">
              <img
                src={pages[page].image}
                alt="archive"
                className="w-100 position-absolute user-drag-none"
              />
            </div>
          </div>
          <div className="col-md-4 d-flex flex-column">
            <h2 className="text-uppercase user-select-none">
              {t("Childhood in Mikołajów")}
            </h2>
            <div className="row gx-4 mt-4 pt-3 pb-1 user-select-none">
              <div className="col-6">
                <span className="fs-14"> {t("Mikołajów, 1980s")}</span>
              </div>
              <div className="col-6 opacity-50">
                <span className="fs-14">
                  {t("Photo: Archive of Mrs. Henryka Thomas")}
                </span>
              </div>
            </div>
            <div className="w-100 my-2 white-line" />
            <div className="row gx-4 pt-1 user-select-none">
              <div className="col-6">
                <div className="me-0">
                  <span className="d-block fs-18 pe-0 me-0">
                    {t(pages[page].textLeft)}
                  </span>
                </div>
              </div>
              <div className="col-6">
                <div className="">
                  <span className="d-block fs-18 pe-1 me-1">
                    {t(pages[page].textRight)}
                  </span>
                  <span className="d-block fs-18 pe-1 me-1 mt-4 fst-italic">
                    {t(pages[page].character)}
                  </span>
                </div>
              </div>
            </div>
            <div className="mt-auto d-flex flex-row pt-3">
              <div
                className={`btn-white me-4 ${
                  page === 0 ? "disabled" : "cursor-pointer"
                }`}
                onClick={() => {
                  changePage(-1);
                }}
              >
                <svg
                  width="50"
                  height="50"
                  viewBox="0 0 50 50"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="25"
                    cy="25"
                    r="24"
                    transform="rotate(-180 25 25)"
                    stroke="currentColor"
                    strokeWidth="2"
                  />
                  <path
                    d="M26.4854 17.9697L19.9707 24.4844L26.4854 30.9991"
                    stroke="currentColor"
                    strokeWidth="2"
                  />
                </svg>
              </div>
              <div
                className={`btn-white ms-3 ${
                  page === 3 ? "disabled" : "cursor-pointer"
                }`}
                onClick={() => {
                  changePage(1);
                }}
              >
                <svg
                  width="50"
                  height="50"
                  viewBox="0 0 50 50"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="25"
                    cy="25"
                    r="24"
                    stroke="currentColor"
                    strokeWidth="2"
                  />
                  <path
                    d="M23.5146 32.0303L30.0293 25.5156L23.5146 19.0009"
                    stroke="currentColor"
                    strokeWidth="2"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ArchiveSecond;
